import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMineRentalOrderList, getRentalOrderList } from "../../../../../../redux/rental/action";
import { Commas, getDateFormate } from "../../../../../Common/AllDateTimeReleventFormate";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import useChatNavigation from "../../../../../Common/useChatNavigation";
import { getSaleStatusText } from "../../../../../Common/Status/Bxpstatus";
import RentalDetailsLabel from "../../../../../Common/Label/RentalDetailsLabel";
import ProfilePic from "../../../../../../assests/imgs/Profileplaceholder.svg";
import { getPostPaginationList } from "../../../../../../redux/project/action";
import { PAGE_SIZE } from "../../../../../../redux/constants";
import OrderPostPagination from "../../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";

export default function CompletedRentalProduct() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate()
  const { letChat } = useChatNavigation();

  const dispatch = useDispatch()
  let lastDisplayedDate = null;

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    const data = {
      index: pageNumber,
      size: PAGE_SIZE,
      status: 4,
      url: 'rental'
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);

  return (
    <>
      <div className ="posted-project umbrellaproject-sec pending-req">
         <OrderPostPagination
          totalitemcounts={listdata?.count}
          size={PAGE_SIZE}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
        {/* <h4>Rental requests ({listdata?.response??.length || 0})</h4> */}
        {
          Array.isArray(listdata?.response) && listdata?.response?.length > 0 ?
            <>
              {listdata?.response?.map((item, index) => {
                const currentDate = item.created_on.split(' ')[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <>
                    <div className ="pending-row" key={index}>
                      {shouldDisplayDate && <h6 className ="date-name">{getDateFormate(item.created_on)}</h6>}
                      <div className ="pending-img">
                        <div className ="row align-items-center">
                          <div className ="col-md-5">
                            <div className ="pending-left">
                              <img src={item?.cover ? item?.cover : ProfilePic} alt="" />
                              <div>
                                <h5>{item?.title}</h5>
                                <h3>$ {Commas(item?.total_price ? item?.total_price : item?.price)}</h3>
                                <RentalDetailsLabel item={item} />
                              </div>
                            </div>
                          </div>
                          <div className ="col-md-3">
                            <div className ="pending-center">
                              <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                              <div>
                                <p>{item?.is_mine == 0 ? 'Seller' : 'Ordered by'}
                                  <p> <img src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`} alt="" /> {item?.rating || 0} ({item?.reviews || 0} reviews)</p>
                                </p>
                                <h5>{item?.first_name} {item?.last_name}</h5>
                              </div>
                            </div>
                          </div>
                          <div className ="col-md-4">
                            <div className ="pending-right">
                              <p className ="accepted">{getSaleStatusText(item?.status)}</p>
                              <button onClick={() => letChat(item)} className ="buttons border-button">
                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" />
                              </button>
                              <button className ="btn-img" onClick={() => { navigate(`/${lan}/dashboard/myorders/rentalproductsdetails/${item?.id}`) }}>

                                <img src={`${CloudStorage.cloudurl}/Assets/Images/common/right-color-icon.svg`} alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )
              })
              }
            </>
            :
            <PostNotFound title={"No Post Found"} height={200} />
        }
      </div>
    </>
  );
}
